"use client";
import Image from "next/image";
import Link from "next/link";
import { StepProps } from "../../Steps.types";

export default function Steps_About_Layout4({ data }: StepProps) {

  const steps = Array.isArray(data?.Step) ? data.Step : [];

  return (
    <div className="px-6 py-8 md:px-24 lg:px-8 lg:py-10 bg-th-bg-col">
      <div className="max-w-xl mx-auto mb-10 text-center lg:max-w-2xl">
        <h1 className="text-3xl xl:text-4xl font-bold text-[#1f1f1f]">
          {data?.title || "Title"}
        </h1>
        <p className="mt-4 text-lg text-[#797979]">
          {data?.description || ""}
        </p>
      </div>

      <div className="max-w-4xl mx-auto">
        <div className="relative">
          {/* Timeline line */}
          {/* <div className="absolute left-1/2 h-full w-1 bg-gray-200 -translate-x-1/2"></div> */}

          {steps.length === 0 ? (
            <p className="text-center text-gray-500 py-6">
              No steps available.
            </p>
          ) : (
            steps.map((item, idx) => {
              const imageUrl = item?.iconImage?.data?.attributes?.url || "";
              const altText =
                item?.iconImage?.data?.attributes?.alternativeText ||
                "Step Image";

              return (
                <div
                  key={idx}
                  className={`mb-8 flex ${
                    idx % 2 === 0 ? "flex-row" : "flex-row-reverse"
                  }`}
                >
                  {/* Timeline dot */}
                  <div className="flex items-center justify-center w-1/6">
                    <div className="z-10 flex items-center justify-center w-8 h-8 bg-black rounded-full ring-4 ring-white">
                      <span className="text-white font-bold">{idx + 1}</span>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="w-5/6 p-6 bg-white rounded-lg shadow-md">
                    <div className="flex flex-col md:flex-row items-center">
                      <div className="w-full md:w-1/3 mb-4 md:mb-0">
                        {imageUrl ? (
                          <Image
                            src={imageUrl}
                            alt={altText}
                            width={200}
                            height={200}
                            className="w-full max-w-xs rounded-lg"
                          />
                        ) : (
                          <div className="w-full h-40 max-w-xs rounded-lg bg-gray-100 flex items-center justify-center text-gray-400 text-sm">
                            No Image
                          </div>
                        )}
                      </div>
                      <div className="w-full md:w-2/3 md:pl-6">
                        <h3 className="text-xl font-bold text-[#1f1f1f] mb-2">
                          {item?.title || "Untitled"}
                        </h3>
                        <p className="text-[#797979] mb-4">
                          {item?.text || ""}
                        </p>
                        {item?.href && (
                          <Link
                            href={item.href}
                            className="inline-block px-4 py-2 text-sm font-semibold text-white bg-black rounded-full hover:bg-gray-800 transition"
                          >
                            {item?.hrefText || "Learn More"}
                          </Link>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
}
